import commonApi from "@/api/common.js";
import $ from "jquery";
import uploadFiles from "@/components/common/uploadFiles";
export const createTopicMX = {
  data() {
    return {
      // 上传文件获取STS凭证的参数
      uploadGetTokenParams: {
        type: 'school_topic',
        partner_id: '',// 学校id
        course_id: '',//课程id
        topic_id: '',//题目id
        sub_id: '',//小题id
      },
      zc_paper: {},
      queryParams: {},
      timeTipShow: false, //五分钟倒计时状态
      showAnswer: true,
      overShow: false, //答题时间为0时，该弹窗显示
      fileLoading: false,
      answered: 0,
      textRadio: "1",
      timer: 0,
      paperList: [],
      preHover: false,
      nextHover: false,
      quitDialogShow: false,
      submitDialogShow: false,
      schduleShow: false, //进度条倒计时显示
      isActive: "", //左侧点击添加选中样式
      totalLength: 0, //题目总数量
      currentNum: 0, //当前题目的顺序
      subjectCont: {},
      activeNames: [],
      checkList: [],
      submitImgDefault: require('@/assets/images/bookContent/question/submit.png'),
      currentImageSrc: require("@/assets/images/bookContent/question/submit.png"),
      submitImgHover: require("@/assets/images/bookContent/question/submit-hover.png"),
      countdownTime: 10, // 倒计时时间，单位：秒
      progressBarWidth: "0%", // 进度条宽度
      timeStr: "",
      subActiveId: "", //组合题的小小题tab选中类名判断
      xciIndex: -1, //显示选词选择的判断
      xciQuestionShow: false,
      subtabIndex: 0, //小小题的下标
      examInfo: {},
      actionUrl: process.env.VUE_APP_BASE_API + "/exam/upload",
      imgurls: [],
      isDarkMode: true,
      notAnswerCount: 0, //未答的题目数量
      sign_topicslist: [], //所有题目的标记状态
      currentSignType: 0, //当前选中题目的标记状态
      fillData: [],
      uselong_minutes: 0, //作答用时
      interval: null,
      setTimer: null,
      topicSubLength: 0,
      time: 0, // 总秒数
      timerId: null, // 计时器ID
      timeTipShow: false,
    }
  },
  created() {
    this.queryParams = this.$route.query;
    // this.uploadGetTokenParams.partner_id = this.$store.state.loginUserInfo.partner.id;
    // this.uploadGetTokenParams.course_id = this.queryParams.course_id;
    this.postTopicList();
  },

  components: {
    uploadFiles
  },
  computed: {
    formattedTime() {
      const hours = Math.floor(this.time / 3600).toString().padStart(2, '0');
      const minutes = Math.floor((this.time % 3600) / 60).toString().padStart(2, '0');
      const seconds = (this.time % 60).toString().padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    },
  },
  watch: {
    timeStr(oldval, newval) {
      if (newval == "00:10:00") {
        this.timeTipShow = true;
      }
    },
  },
  updated() {
    // 更新 localStorage
    localStorage.setItem('timer', this.time);
  },
  beforeDestroy() {
    window.clearInterval(this.setTimer); // 清除定时器
    this.setTimer = null; // 将引用设置为null
    // 在组件销毁前停止计时器
    window.clearInterval(this.timerId);
    // 保存计时器状态到 localStorage
    localStorage.removeItem('timer');
    // 重置计时器状态
    this.time = 0;
    this.timerId = null;
  },
  methods: {
    startTimer() {
      this.timerId = setInterval(() => {
        this.time++;
      }, 1000);
    },
    uploadFilesClick(item, index) {
      this.tiankongindex = index;
      let uploaddom = "upload" + item.answer_id;
      this.$refs[uploaddom][0].uploadFilesHandle()
    },
    //简答题删除已上传的图片
    delectImgClick(index, pindex) {
      if (pindex != undefined) {
        this.subjectCont.topic_sub[pindex].answer_img[1] =
          this.subjectCont.topic_sub[pindex].answer_img[1].filter(
            (item, idx) => {
              return idx != index;
            }
          );
      } else {
        this.subjectCont.topic_sub[0].answer_img[1] =
          this.subjectCont.topic_sub[0].answer_img[1].filter((item, idx) => {
            return idx != index;
          });
      }
      this.$forceUpdate();
    },
    //组合题的小小题点击
    subtabClick(topic_id, item, index) {
      this.subActiveId = "sub" + topic_id + "-" + item.sub_id;
      this.uploadGetTokenParams.sub_id = item.sub_id;
      this.isActive = topic_id;
      this.subtabIndex = index;
      if (this.$refs.bgQuestion) {
        this.$refs.bgQuestion.scrollTop = 0;
      }
      if (this.$refs.rightCont) {
        this.$refs.rightCont.scrollTop = 0;
      }
    },
    // 简答题上传文件
    uploadUrlChange(path) {
      if (this.topicSubLength > 1) {
        //组合题
        this.subjectCont.topic_sub[this.subtabIndex].answer_img[1].push(path);
      } else {
        this.subjectCont.topic_sub[0].answer_img[1].push(path);
      }
      this.$forceUpdate()
    },
    //填空题删除已上传的图片
    delectFillImgClick(index, pindex) {
      if (pindex != undefined) {
        this.subjectCont.topic_sub[pindex].answer_img[index] = [];
      } else {
        this.subjectCont.topic_sub[0].answer_img[index] = [];
      }
      this.$forceUpdate()
    },
    //填空题上传文件
    uploadUrlFillChange(path) {
      if (this.topicSubLength > 1) {
        //组合题
        this.subjectCont.topic_sub[this.subtabIndex].answer_img[
          this.subtabIndex + 1
        ] = [path]
      } else {
        this.subjectCont.topic_sub[0].answer_img[this.tiankongindex] = [path];
      }
      this.$forceUpdate()
    },
    // 文件上传成功确认事件
    uploadClose() {
    },
    //交卷按钮点击事件
    submitClick() {
      if (this.showAnswer) {
        this.dealUserAnswer();
        this.submitDialogShow = true;
      }
    },
    changeImageOnHover(isHovered) {
      this.submitImgDefault = isHovered
        ? this.submitImgHover
        : this.currentImageSrc;
    },
    //获取练习题题目
    postTopicList() {
      let { type } = this.queryParams;
      let url = "";
      let params = {
        partnercode: this.queryParams.partnercode,
        course_id: this.queryParams.course_id,
      };
      if (type == "practice" || type == "wrongpractice") {
        //练习
        url = "/school/topic/zcPaperTopic";
      } else if (type == "exam" || type == "hw") {
        //考试&作业
        url = "/school/topic/getPaperTopic";
        params.paper_id = this.queryParams.paper_id;
        if (type == 'exam') {
          params.flag = 'tt';
          params.exam_id = this.queryParams.type_id;
        } else if (type == 'hw') {
          params.flag = 'hw';
          params.hw_id = this.queryParams.type_id;
        }
      }
      else {
        //错题本
        url = "/school/topic/errPaperTopic";
      }
      // commonApi
      //   .postTopicList(params, url)
      //   .then((res) => {
      //     if (res.code == 0) {
      //       if (this.queryParams.type != 'exam') {
      //         //非考试进行正记时
      //         // 从 localStorage 中恢复计时状态
      //         const savedTime = localStorage.getItem('timer');
      //         if (savedTime) {
      //           this.time = parseInt(savedTime, 10);
      //         }
      //         // 开始计时器
      //         this.startTimer();
      //       }
      //       if (this.queryParams.type == 'exam') {
      //         this.zc_paper = res.data.exam;
      //         this.zc_paper.customAnswerTit = res.data.exam.exam;
      //         this.timer = res.data.timer; //倒计时时间/秒
      //       } else if (this.queryParams.type == 'hw') {
      //         this.zc_paper = res.data.hw;
      //         this.zc_paper.customAnswerTit = res.data.hw.title;
      //       } else {
      //         this.zc_paper = res.data.zc_paper;
      //         this.zc_paper.customAnswerTit = res.data.zc_paper.paper;
      //       }
      //       this.paperList = res.data.topic_list;
      //       this.totalLength = res.data.topic_list.reduce(
      //         (total, currentObject) => {
      //           return (
      //             total + (currentObject.list ? currentObject.list.length : 0)
      //           );
      //         },
      //         0
      //       );
      //       this.copypaperList = res.data.topic_list.reduce(
      //         (acc, item) => acc.concat(item.list),
      //         []
      //       );
      //       this.activeNames = [];
      //       this.sign_topicslist = [];
      //       this.zuheTopic_id = [];
      //       for (var i = 0; i < res.data.topic_list.length; i++) {
      //         this.activeNames.push(i);
      //         for (var j = 0; j < res.data.topic_list[i].list.length; j++) {
      //           if (res.data.topic_list[i].list[j].issign == 1) {
      //             this.sign_topicslist.push(
      //               res.data.topic_list[i].list[j].topic_id
      //             );
      //           }
      //           //组合题的话，把大题
      //           if (res.data.topic_list[i].list[j].topic_sub.length > 1) {
      //             this.zuheTopic_id.push(
      //               res.data.topic_list[i].list[j].topic_id
      //             );
      //           }
      //         }
      //       }
      //       //设置第一题默认选中
      //       this.$nextTick(() => {
      //         var subjectFirst = document.getElementById("subjectFirst");
      //         if (subjectFirst) {
      //           subjectFirst.click();
      //         }
      //       });
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   })
      //   .catch((err) => { });
    },
    //左侧题目点击事件
    subjectClick(id, items, outItem, ind, objIndex) {
      if (this.$refs.bgQuestion) {
        this.$refs.bgQuestion.scrollTop = 0;
      }
      if (this.$refs.rightCont) {
        this.$refs.rightCont.scrollTop = 0;
      }
      this.topicSubLength = items.topic_sub.length;//用于区分组合题的上传文件和非组合题的上传文件
      this.subtabIndex = 0;
      this.signTopic_sub = items.topic_id; //标记三角图标显示
      this.uploadGetTokenParams.topic_id = this.signTopic_sub;
      this.currentSignType = items.issign; //获取当前题目的标记状态
      //组合题除外
      if (items.topic_sub.length == 1) {
        this.uploadGetTokenParams.sub_id = items.topic_sub[0].sub_id;
        for (var i = 0; i < items.topic_sub.length; i++) {
          //单选题和判断题直接赋值
          if (items.type_id == 1 || items.type_id == 7) {
            if (
              items.topic_sub[i].user_answer != undefined &&
              items.topic_sub[i].user_answer.length
            ) {
              items.topic_sub[i].user_answer =
                items.topic_sub[i].user_answer[0];
            }
            // items.topic_sub[i].user_answer = items.topic_sub[i].user_answer;
          }
          //多选题需要转纯数字类型，才能回显上
          if (items.type_id == 2) {
            if (typeof items.topic_sub[i].user_answer == "number") {
              items.topic_sub[i].user_answer = [
                items.topic_sub[i].user_answer,
              ].map((numStr) => parseInt(numStr));
            } else {
              items.topic_sub[i].user_answer = items.topic_sub[
                i
              ].user_answer.map((numStr) => parseInt(numStr));
            }
          }
          for (var j = 0; j < items.topic_sub[i].topic_answer.length; j++) {
            //填空题，需要判断
            if (items.type_id == 3) {
              let key = j + 1;
              let val = "";
              if (items.topic_sub[i].user_answer[key]) {
                items.topic_sub[i].user_answer[key] =
                  items.topic_sub[i].user_answer[key];
                items.topic_sub[i].topic_answer[j]["textRadio"] = "1";
              } else {
                items.topic_sub[i].user_answer[key] = "";
                items.topic_sub[i].topic_answer[j]["textRadio"] = "1";
              }
              if (
                items.topic_sub[i].answer_img[key] != undefined &&
                items.topic_sub[i].answer_img[key].length
              ) {
                items.topic_sub[i].answer_img[key] =
                  items.topic_sub[i].answer_img[key];
                items.topic_sub[i].topic_answer[j]["textRadio"] = "0";
              } else {
                items.topic_sub[i].answer_img[key] = [];
                items.topic_sub[i].topic_answer[j]["textRadio"] = "1";
              }
            }
            //简答题，需要判断
            if (items.type_id == 4) {
              let key = j + 1;
              let val = "";
              //简答题-文本
              if (items.topic_sub[i].user_answer[key]) {
                items.topic_sub[i].user_answer[key] =
                  items.topic_sub[i].user_answer[key];
              } else {
                items.topic_sub[i].user_answer[key] = "";
              }
              //简答题-图片
              if (items.topic_sub[i].answer_img[key]) {
                items.topic_sub[i].answer_img[key] =
                  items.topic_sub[i].answer_img[key];
              } else {
                items.topic_sub[i].answer_img[key] = [];
              }
            }
            //选词填空题
            if (items.type_id == 9) {
              let key = j + 1;
              let val = "";
              if (items.topic_sub[i].user_answer[key]) {
                items.topic_sub[i].user_answer[key] =
                  items.topic_sub[i].user_answer[key];
              } else {
                items.topic_sub[i].user_answer[key] = "";
              }
              if (items.topic_sub[i].answer_img[key]) {
                items.topic_sub[i].answer_img[key] =
                  items.topic_sub[i].answer_img[key];
              } else {
                items.topic_sub[i].answer_img[key] = [];
              }
            }
          }
        }
      } else {
        for (var i = 0; i < items.topic_sub.length; i++) {
          if (items.topic_sub[i].type_id == 1 || items.topic_sub[i].type_id == 7) {
            if (
              items.topic_sub[i].user_answer != undefined &&
              items.topic_sub[i].user_answer.length
            ) {
              items.topic_sub[i].user_answer =
                items.topic_sub[i].user_answer[0];
            }
          }
          if (items.topic_sub[i].type_id == 2) {
            items.topic_sub[i].user_answer = items.topic_sub[i].user_answer.map(
              (numStr) => parseInt(numStr)
            );
          }
          for (var j = 0; j < items.topic_sub[i].topic_answer.length; j++) {
            //填空题，需要判断
            if (items.topic_sub[i].type_id == 3) {
              let key = j + 1;
              let val = "";
              if (items.topic_sub[i].user_answer[key]) {
                items.topic_sub[i].user_answer[key] =
                  items.topic_sub[i].user_answer[key];
                items.topic_sub[i].topic_answer[j]["textRadio"] = "1";
              } else {
                items.topic_sub[i].user_answer[key] = "";
                items.topic_sub[i].topic_answer[j]["textRadio"] = "1";
              }
              if (
                items.topic_sub[i].answer_img[key] != undefined &&
                items.topic_sub[i].answer_img[key].length
              ) {
                items.topic_sub[i].answer_img[key] =
                  items.topic_sub[i].answer_img[key];
                items.topic_sub[i].topic_answer[j]["textRadio"] = "0";
              } else {
                items.topic_sub[i].answer_img[key] = [];
                items.topic_sub[i].topic_answer[j]["textRadio"] = "1";
              }
            }
            //简答题，需要判断
            if (items.topic_sub[i].type_id == 4) {
              let key = j + 1;
              let val = "";
              //简答题-文本
              if (items.topic_sub[i].user_answer[key]) {
                items.topic_sub[i].user_answer[key] =
                  items.topic_sub[i].user_answer[key];
              } else {
                items.topic_sub[i].user_answer[key] = "";
              }
              //简答题-图片
              if (items.topic_sub[i].answer_img[key]) {
                items.topic_sub[i].answer_img[key] =
                  items.topic_sub[i].answer_img[key];
              } else {
                items.topic_sub[i].answer_img[key] = [];
              }
            }
            //选词填空题
            if (items.topic_sub[i].type_id == 9) {
              let key = j + 1;
              let val = "";
              if (items.topic_sub[i].user_answer[key]) {
                items.topic_sub[i].user_answer[key] =
                  items.topic_sub[i].user_answer[key];
              } else {
                items.topic_sub[i].user_answer[key] = "";
              }
              if (items.topic_sub[i].answer_img[key]) {
                items.topic_sub[i].answer_img[key] =
                  items.topic_sub[i].answer_img[key];
              } else {
                items.topic_sub[i].answer_img[key] = [];
              }
            }
          }
        }
      }
      var allScore = items.topic_sub.reduce(
        (accumulator, currentValue) => accumulator + Number(currentValue.score),
        0
      );
      console.log(items, 'items.....')
      this.subjectCont = Object.assign(
        {
          ps_title: outItem.ps_title,
          subtitle: outItem.subtitle,
          index1: objIndex.index1,
          index2: objIndex.index2,
          index3: objIndex.index3,
          titNum: this.NumberString(objIndex.index1 + 1),
          subtitleL: outItem.list.length,
          smallScore: allScore,
        },
        items
      );
      this.xciIndex = -1;
      this.isActive = items.topic_id;
      //组合题，通过topic_id+sub_id区分唯一性
      if (items.topic_sub.length > 1) {
        //小小题选中的标识
        this.subActiveId =
          "sub" +
          items.topic_id +
          "-" +
          items.topic_sub[this.subtabIndex].sub_id;
      }
      // //输出该元素的下标+1，就是当前题目的序号
      this.currentNum =
        this.copypaperList.findIndex((ids) => ids.id === items.id) + 1;
      //当前第一题，上一题按钮置灰
      if (this.currentNum == 1) {
      }
      //当前最后一题，下一题按钮置灰
      if (this.currentNum == this.totalLength) {
      }
      //处理作答记录
      this.dealUserAnswer();
    },
    dealUserAnswer(str) {
      var answer_psub = {};
      var answerList = this.paperList;
      console.log(answerList)
      //一级遍历
      for (var i = 0; i < answerList.length; i++) {
        var answer_topic = {};
        //二级遍历
        for (var j = 0; j < answerList[i].list.length; j++) {
          var answer_topicsub = {};
          var topic_key =
            answerList[i].list[j].topic_id +
            "_" +
            answerList[i].list[j].type_id;
          //三级遍历
          for (var k = 0; k < answerList[i].list[j].topic_sub.length; k++) {
            var topicsub_key =
              answerList[i].list[j].topic_sub[k].sub_id +
              "_" +
              answerList[i].list[j].topic_sub[k].type_id;
            // 选择类型的题目，答案是选择的 answer_id
            if (
              ["", 1, 2, 7, 8].includes(
                answerList[i].list[j].topic_sub[k].type_id
              )
            ) {
              var answer = [];
              // 单选题 & 多选题 & 判断题,user_answer为字符串格式
              // 单选题 & 判断题
              if (
                answerList[i].list[j].topic_sub[k].type_id == 1 ||
                answerList[i].list[j].topic_sub[k].type_id == 7
              ) {
                answer.push(answerList[i].list[j].topic_sub[k].user_answer);
              }
              //多选题
              if (
                answerList[i].list[j].topic_sub[k].type_id == 2 &&
                answerList[i].list[j].topic_sub[k].user_answer.length
              ) {
                answer.push(
                  answerList[i].list[j].topic_sub[k].user_answer
                    ? answerList[i].list[j].topic_sub[k].user_answer.join()
                    : ""
                );
              }
              // 记录作答内容
              answer_topicsub[topicsub_key] = {
                isauto: 0,
                user_answer: answer.join(),
              };
            } else {
              if (
                answerList[i].list[j].topic_sub[k].type_id == 3 ||
                answerList[i].list[j].topic_sub[k].type_id == 4 ||
                answerList[i].list[j].topic_sub[k].type_id == 9
              ) {
                var user_answer =
                  answerList[i].list[j].topic_sub[k].brief_answer; //对象
              } else {
                var user_answer = answerList[i].list[j].topic_sub[k].user_answer; //对象
              }
              var answer_img = answerList[i].list[j].topic_sub[k].answer_img; //对象
              //填空题&简答题&选词填空，user_answer为对象格式
              var answer = {},
                answer_file = {};
              for (
                var q = 0;
                q < answerList[i].list[j].topic_sub[k].topic_answer.length;
                q++
              ) {
                var answer_id =
                  answerList[i].list[j].topic_sub[k].topic_answer[q].answer_id;
                var textValue = user_answer[q + 1]; //填写的内容
                var imgValue = answer_img[q + 1]; //图片地址
                answer[answer_id] = textValue;
                answer_file[answer_id] = imgValue;
              }
              // 记录作答内容
              answer_topicsub[topicsub_key] = {
                isauto: 0,
                user_answer: answer,
                answer_img: answer_file,
              };
            }
          }
          answer_topic[topic_key] = answer_topicsub;
        }
        answer_psub[answerList[i].psub_id] = answer_topic;
      }

      this.submitExam(answer_psub, str);
    },
    //显示选词备选项
    textFocus(event, index, type) {
      if (type == "zuheti") {
        this.temporaryIndex = index + 1; //临时存储的下标
        this.xciIndex = index;
        const element = event.currentTarget;
        if (!element.classList.contains("xcActive")) {
          this.$set(
            this.subjectCont.topic_sub[this.subtabIndex],
            "xciQuestionShow",
            true
          );
        } else {
          this.$set(
            this.subjectCont.topic_sub[this.subtabIndex],
            "xciQuestionShow",
            false
          );
          this.xciIndex = -1;
        }
      } else {
        this.temporaryIndex = index + 1; //临时存储的下标
        this.xciIndex = index;
        const element = event.currentTarget;
        if (!element.classList.contains("xcActive")) {
          this.$set(this.subjectCont.topic_sub[0], "xciQuestionShow", true);
        } else {
          this.$set(this.subjectCont.topic_sub[0], "xciQuestionShow", false);
          this.xciIndex = -1;
        }
      }
    },
    getFile(obj, options) { },
    questionChange(val, type) {
      if (type == "zuheti") {
        this.subjectCont.topic_sub[this.subtabIndex].brief_answer[
          this.temporaryIndex
        ] = val;
      } else {
        this.subjectCont.topic_sub[0].brief_answer[this.temporaryIndex] = val;
      }
      this.$forceUpdate();
    },
    processUserAnswer(obj) {
      // 遍历对象的所有键
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          // 如果键对应的值是对象，则递归处理
          if (typeof obj[key] === 'object') {
            if (key == 'user_answer' || key == 'answer_img') {
              // 如果键是 user_answer 或 answer_img 并且它的值是对象，则使用 JSON.stringify 进行加工
              obj[key] = JSON.stringify(obj[key]);
            }
            this.processUserAnswer(obj[key]);
          }
        }
      }
      return obj;
    },
    //保存提交答题数据
    submitExam(answer_list, str) {
      let { type } = this.queryParams;
      let url = "";
      let params = {
        answer_list: JSON.stringify(this.processUserAnswer(answer_list)),
        partnercode: this.queryParams.partnercode,
        course_id: this.queryParams.course_id,
        submit: str ? 1 : 0,
        paper_id: 0,
        sign_topics: this.sign_topicslist.join(","),
      };
      if (type == "practice" || type == "wrongpractice") {
        //练习
        url = "/school/topic/submitZcExam";
      } else if (type == "exam" || type == "hw") {
        //考试&作业
        url = "/school/topic/submitExam";
        params.paper_id = this.queryParams.paper_id;
        if (type == 'exam') {
          params.flag = 'tt';
          params.exam_id = this.queryParams.type_id;
        } else if (type == 'hw') {
          params.flag = 'hw';
          params.hw_id = this.queryParams.type_id;
        }
      } else {
        //错题本
        url = "/school/topic/submitZcTmpExam";
      }
      commonApi
        .postSubmitPaper(params, url)
        .then((res) => {
          if (res.code == 0) {
            this.set_topic_done(answer_list);
            if (this.queryParams.type == 'exam') {
              if (!str) {
                //获取考试倒计时时间
                commonApi.examTimer({
                  partnercode: this.queryParams.partnercode,
                  exam_id: this.queryParams.type_id
                }).then((res) => {
                  if (res.code == 0) {
                    this.timer = res.data.timer; //倒计时时间/秒
                    if (res.data.timer == 0) {
                      window.clearInterval(this.setTimer);
                      //调用交卷接口
                      this.dealUserAnswer("submit");
                    } else {
                      window.clearInterval(this.setTimer);
                      this.timego();
                    }
                  }
                }).catch((err) => {

                })
              }
            } else {
            }
            if (str == 'submit') {
              if (this.queryParams.type != 'exam') {
                clearInterval(this.timerId);
                this.time = 0;
                this.timerId = null;
                localStorage.removeItem('timer');
              }
              //考试返回列表页面，练习和错题本和作业跳转报告详情页面
              if (this.queryParams.type == 'exam') {
                this.$router.push({
                  path: "/learningDetail",
                  query: {
                    partnercode: this.queryParams.partnercode,
                    course_id: this.queryParams.course_id,
                    activeName: this.queryParams.type == 'exam' ? 'detailExam' : 'detailTask'
                  },
                });
              } else {
                let query = {
                  partnercode: this.queryParams.partnercode,
                  course_id: this.queryParams.course_id,
                  type: this.queryParams.type
                }
                if (this.queryParams.type == 'hw') {
                  query.type_id = this.queryParams.type_id
                  query.paper_id = this.queryParams.paper_id
                }
                //去报告详情页面
                this.$router.replace({
                  path: "/topicres",
                  query,
                });
              }
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => { });
    },
    //退出当前考试
    quitClick(str) {
      if (str == 'exam') {
        this.$router.push({ path: '/learningDetail', query: { course_id: this.queryParams.course_id, partnercode: this.queryParams.partnercode, activeName: 'detailExam' } })
      } else if (str == 'hw') {
        this.$router.push({ path: '/learningDetail', query: { course_id: this.queryParams.course_id, partnercode: this.queryParams.partnercode, activeName: 'detailTask' } })
      } else if (str == 'practice') {
        //练习
        this.$router.push({ path: '/learningDetail', query: { course_id: this.queryParams.course_id, partnercode: this.queryParams.partnercode, activeName: 'detailExercise' } })
      } else {
        //错题本
        this.$router.push({ path: '/learningDetail', query: { course_id: this.queryParams.course_id, partnercode: this.queryParams.partnercode, activeName: 'detailWrongTopic' } })
      }
      // this.$router.go(-1);
    },
    timego() {
      let that = this;
      this.timeGoing(this.timer);
      this.setTimer = window.setInterval(() => {
        this.timer -= 1;
        this.timeGoing(this.timer);
      }, 1000);
    },
    timeGoing(time) {
      if (time >= 0) {
        this.timeStr = this.settoTime(time);
      } else {
        window.clearInterval(this.setTimer);
        //调用交卷接口
        this.dealUserAnswer("submit");
      }
    },
    //格式化秒数
    settoTime(s) {
      var t;
      if (s > -1) {
        var hour = Math.floor(s / 3600);
        var min = Math.floor(s / 60) % 60;
        var sec = s % 60;
        if (hour < 10) {
          t = "0" + hour + ":";
        } else {
          t = hour + ":";
        }
        if (min < 10) {
          t += "0";
        }
        t += min + ":";
        if (sec < 10) {
          t += "0";
        }
        t += sec.toFixed(0);
      }
      return t;
    },
    // processUserAnswersss(obj){
    //     // 遍历对象的所有键
    //     for (const key in obj) {
    //         if (obj.hasOwnProperty(key)) {
    //             // 如果键对应的值是对象，则递归处理
    //             console.log(typeof obj[key],key,'8888888')
    //             if (typeof obj[key] === 'object') {
    //                 if (key == 'user_answer' || key == 'answer_img') {
    //                     // 如果键是 user_answer 或 answer_img 并且它的值是对象，则使用 JSON.stringify 进行加工
    //                     obj[key] = JSON.parse(obj[key]);
    //                 }
    //                 this.processUserAnswersss(obj[key]);
    //             }
    //         }
    //     }
    //     return obj;
    // },
    convertJsonStrings(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          if (key === 'user_answer' || key === 'answer_img') {
            try {
              obj[key] = JSON.parse(value);
            } catch (error) {
              continue;
            }
          } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            this.convertJsonStrings(value);
          }
        }
      }
      return obj;
    },
    //更新题目选项卡样式
    set_topic_done(answer) {
      var answerJSON = this.convertJsonStrings(answer);
      var answer = answerJSON;
      console.log(answerJSON, 'answerJSON.....')
      var elements = document.querySelectorAll(".checksubject");
      // 遍历这些元素
      elements.forEach(function (element) {
        element.classList.remove("checksubject");
      });
      // 已经做过的题目
      var topic_ids = [];
      // 遍历分组
      for (var i in answer) {
        // 遍历大题
        for (var j in answer[i]) {
          var topic = j.split("_");
          var topic_id = topic[0]; // 大题ID
          //遍历小题
          for (var k in answer[i][j]) {
            var topicsub = k.split("_");
            var topicsub_id = topicsub[0]; // 小题ID
            var user_answer = answer[i][j][k]["user_answer"]; // 作答的内容
            if (user_answer && topic_ids.indexOf(topic_id) == -1) {
              if ((typeof user_answer == "string" || typeof user_answer == "number") && user_answer != "") {
                $(".answer-option")
                  .find("span[topic-id='" + topic_id + "']")
                  .addClass("checksubject");
              }
              if (typeof user_answer == "object") {
                var hasvalue = Object.values(user_answer).some((value) => {
                  return value !== null && value !== undefined && value !== "";
                });
                if (hasvalue) {
                  $(".answer-option")
                    .find("span[topic-id='" + topic_id + "']")
                    .addClass("checksubject");
                }
              }
            }
            var user_answer_img = answer[i][j][k]["answer_img"]; // 上传的图片
            if (user_answer_img) {
              var hasvalue2 = Object.values(user_answer_img).some((value) => {
                return (
                  value !== null &&
                  value !== undefined &&
                  value !== "" &&
                  value.length
                );
              });
              if (hasvalue2) {
                $(".answer-option")
                  .find("span[topic-id='" + topic_id + "']")
                  .addClass("checksubject");
              }
            }
          }
        }
      }
      this.answered = $(".checksubject").length;
      const allClassAElements = document.querySelectorAll(".subSpan");
      this.notAnswerCount = 0;
      allClassAElements.forEach((element) => {
        if (!element.classList.contains("checksubject")) {
          this.notAnswerCount++;
        }
      });
    },
    //上一题
    backClick() {
      if (this.showAnswer) {
        if (this.currentNum > 1) {
          //获取上一题
          let { id } = this.findPreviousItemById(
            this.copypaperList,
            this.isActive
          );
          let refArray = "subject" + id;
          this.$refs[refArray][0].click();
          console.log("可点击");
        } else {
          console.log("不可点击");
        }
      }
    },
    //下一题
    nextClick() {
      if (this.showAnswer) {
        //可点击
        if (this.currentNum < this.totalLength) {
          //获取下一题
          let { id } = this.findNextItemById(this.copypaperList, this.isActive);
          let refArray = "subject" + id;
          this.$refs[refArray][0].click();
        } else {
          console.log("不可点击", this.currentNum, this.totalLength);
        }
      }
    },
    //查找上一道题
    findPreviousItemById(array, targetId) {
      let previousItem = null;
      for (let i = 0; i < array.length; i++) {
        if (array[i].id === targetId) {
          // 如果找到了目标ID，返回前一项（如果这是第一个元素，则previousItem仍为null）
          return previousItem;
        } else {
          // 否则，将当前项存储为前一项，继续下一个循环
          previousItem = array[i];
        }
      }
      // 如果循环结束都没有找到目标ID，返回null或其他默认值
      return null;
    },
    //查找下一道题
    findNextItemById(array, id) {
      const currentIndex = array.findIndex((item) => item.id === id);
      if (currentIndex !== -1 && currentIndex < array.length - 1) {
        // 找到了当前id，并且它不是数组中的最后一个元素
        return array[currentIndex + 1];
      } else {
        // 如果是最后一个元素或者没有找到，返回null或者其他处理
        return null;
      }
    },
    //右上角交卷点击事件
    submitAllAnswer() {
      this.dealUserAnswer("submit");

    },
    //标记题目
    signAnserClick() {
      if (this.showAnswer) {
        //当前选中题目的topic_id；
        var currentTopic_id =
          this.paperList[this.subjectCont.index1].list[this.subjectCont.index2]
            .topic_id;
        if (this.currentSignType) {
          //当前已标记，需要删除topic_id；
          this.sign_topicslist = this.sign_topicslist.filter(
            (item) => item != currentTopic_id
          );
          this.paperList[this.subjectCont.index1].list[
            this.subjectCont.index2
          ].issign = 0;
          this.currentSignType = 0; //同步标记按钮切换——标记&已标记
        } else {
          //当前未标记，需要追加topic_id
          this.sign_topicslist = [];
          this.paperList[this.subjectCont.index1].list[
            this.subjectCont.index2
          ].issign = 1;
          this.currentSignType = 1; //同步标记按钮切换——标记&已标记
          for (var i = 0; i < this.paperList.length; i++) {
            for (var j = 0; j < this.paperList[i].list.length; j++) {
              if (this.paperList[i].list[j].issign) {
                this.sign_topicslist.push(this.paperList[i].list[j].topic_id);
              }
            }
          }
        }
        this.dealUserAnswer();
      }
    },
    fraction(str) {
      if (str) {
        let regex = /共(\d+(\.\d+)?)分/;
        let result = str.match(regex);

        if (result) {
          var number = Number(result[1]);
        }
      }
      return number;
    },
    //处理大题的标题
    NumberString(n) {
      const numMap = {
        0: "零",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
        7: "七",
        8: "八",
        9: "九",
      };
      return (
        String(n)
          .split("")
          .map((digit) => numMap[digit])
          .join("") + ". "
      );
    },

  },
}